import { useShowLogikErrors } from '../hooks/form.hooks';

export const LogikGlobalErrors = (): JSX.Element => {
    useShowLogikErrors();

    return <></>;
};
